/** Row x col grid dimensions (e.g. 4x2 = 2 rows, 4 columns). */
/** Every grid a protocol pane arrangement may use. Single source of truth: the
 * LayoutKey union and every runtime validator derive from this array. */
export const LAYOUT_KEYS = ['1x1', '1x2', '2x2', '2x3', '3x2', '3x3', '4x2'];
